import { Badge } from '../../badge/entities/badge.entity';
import { NavigationLink } from './navigation-link.entity';

export interface LinkItem {
    readonly label: string;
    readonly navigationLink: NavigationLink;
    readonly onHover?: (event: MouseEvent) => void;
}

export interface NavigationItem extends LinkItem {
    readonly icon?: string;
    readonly badge?: Badge;
    readonly dropmenuItems?: NavigationItem[];
    readonly iconPosition?: NavigationItemIconPosition;
}

export interface DropmenuIsOpen {
    readonly isOpen?: boolean;
}

export interface OpenableNavigationItem extends NavigationItem, DropmenuIsOpen {}

export enum NavigationItemIconPosition {
    'Default' = '',
    'Start' = '-sh-align-start',
    'End' = '-sh-align-end'
}
